// Custom modules
import http from "./httpService";
import { apiSkillsURL } from "./config.json";

export async function getData() {
  // This is an array of skills to display on the about page
  const results = await http.get(apiSkillsURL);
  return results.data;
}

export default {
  getData,
};
